import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Tabs, Alert, Card, Table, Divider, Tag, Modal } from 'antd'

import { Chart, Point, Line, Axis, Area, Tooltip, Coordinate } from 'bizcharts'
import DataSet from '@antv/data-set'

import { req_single_cms_school_student, req_single_cms_learnmap_yearplan, req_single_cms_learnmap_talent_tab, req_single_cms_learnmap_completed_index } from '../../api'
import { getNowAcademicYear, getNowAcademicSemester } from '../../utils/dateUtil'

import CoursemapStudentSuggestCourseModal from './coursemap-student-suggest-course-modal'
import CoursemapStudentAbilityChartModal from './coursemap-student-ability-chart-modal'
const { TabPane } = Tabs
class CoursemapStudentCompletedIndex extends Component {
    // 基礎通用參數 //////////////////////////////////////////////  
    state = {
        item: null,
        items: [],
        deviceWidth: 0,
        loading: false,
        tableloading: false,
        chartloading: false,
        nowAcademicYear: getNowAcademicYear(new Date()),
        nowAcademicSemester: getNowAcademicSemester(new Date()),
        maxGrade: 72,
        defaultKey: null,
        talents: [],
        student: null,
        department: null,
        enrollmnetYear: null,
        showGradeSemester: null,
        gradeSemesters: [],
        nidTalent: null,
        prodata: [],
        comdata: [],
        isSuggestModal: false,
        isChartModal: false,
    }

    componentDidMount() {
        window.addEventListener('resize', this.resize.bind(this))
        this.resize()
        this.api_init_items()
    }

    // componentWillUnmount() {
    //     window.removeEventListener("resize", this.resize.bind(this))
    // }

    resize() {
        this.setState({ deviceWidth: window.innerWidth });
    }

    // 遠端數據處理 //////////////////////////////////////////////

    api_init_items = async () => {
        const { userCode, token } = this.props.user
        this.setState({ loading: true, items: [] })
        const result = await req_single_cms_school_student(userCode, token)
        //  console.log(result)
        if (result) {
            const { nowAcademicYear, nowAcademicSemester } = this.state
            const { enrollmnetYear, studentId, departmentInsideCode } = result
            let grade = nowAcademicYear - enrollmnetYear 
            // console.log('nowAcademicYear',nowAcademicYear)
            // console.log('enrollmnetYear',enrollmnetYear)
            // console.log('nowAcademicSemester',nowAcademicSemester)
            let semester = 1
            if (nowAcademicSemester === '2') {
                grade = grade + 1
                semester = nowAcademicSemester - 1
            }
            else {
                if (grade === 0) {
                    //一年級上學期
                    grade = 1
                    semester = 1
                }
                else {
                    semester = 2
                }
            }
            // 目前可顯示最大年級學期
            const maxGrade = grade.toString() + semester.toString()
     
            // 當前的年級學期
            const showGradeSemester = grade.toString() + semester.toString()
            // 可用的年級學期清單
            //console.log(showGradeSemester)
            const gradeSemesters = this.list_grade_semester(showGradeSemester)
            this.setState({ student: studentId, department: departmentInsideCode, enrollmnetYear, showGradeSemester, gradeSemesters, maxGrade })

            const yearplan = await req_single_cms_learnmap_yearplan(result, token)
            // console.log(yearplan)
            if (yearplan) {
                const tab = await req_single_cms_learnmap_talent_tab(userCode, token)
                if (tab) {
                    if (tab.total > 0) {
                        const talents = tab.data
                        const defaultKey = talents[0].nidTalent
                        this.setState({ talents, defaultKey })
                        this.tab_change(defaultKey)
                    }
                }
                this.setState({ loading: false })
            } else {
                this.setState({ loading: false })
            }
        } else {
            this.setState({ loading: false })
        }
    }

    list_grade_semester = (gradeSemester) => {
        let result = [];
        switch (gradeSemester) {
            case '11':
                result.push({ value: '11', text: '一年級 上學期' })
                break;
            case '12':
                result.push({ value: '11', text: '一年級 上學期' })
                result.push({ value: '12', text: '一年級 下學期' })
                break;
            case '21':
                result.push({ value: '11', text: '一年級 上學期' })
                result.push({ value: '12', text: '一年級 下學期' })
                result.push({ value: '21', text: '二年級 上學期' })
                break;
            case '22':
                result.push({ value: '11', text: '一年級 上學期' })
                result.push({ value: '12', text: '一年級 下學期' })
                result.push({ value: '21', text: '二年級 上學期' })
                result.push({ value: '22', text: '二年級 下學期' })
                break;
            case '31':
                result.push({ value: '11', text: '一年級 上學期' })
                result.push({ value: '12', text: '一年級 下學期' })
                result.push({ value: '21', text: '二年級 上學期' })
                result.push({ value: '22', text: '二年級 下學期' })
                result.push({ value: '31', text: '三年級 上學期' })
                break;
            case '32':
                result.push({ value: '11', text: '一年級 上學期' })
                result.push({ value: '12', text: '一年級 下學期' })
                result.push({ value: '21', text: '二年級 上學期' })
                result.push({ value: '22', text: '二年級 下學期' })
                result.push({ value: '31', text: '三年級 上學期' })
                result.push({ value: '32', text: '三年級 下學期' })
                break;
            case '41':
                result.push({ value: '11', text: '一年級 上學期' })
                result.push({ value: '12', text: '一年級 下學期' })
                result.push({ value: '21', text: '二年級 上學期' })
                result.push({ value: '22', text: '二年級 下學期' })
                result.push({ value: '31', text: '三年級 上學期' })
                result.push({ value: '32', text: '三年級 下學期' })
                result.push({ value: '41', text: '四年級 上學期' })
                break;
            case '42':
                result.push({ value: '11', text: '一年級 上學期' })
                result.push({ value: '12', text: '一年級 下學期' })
                result.push({ value: '21', text: '二年級 上學期' })
                result.push({ value: '22', text: '二年級 下學期' })
                result.push({ value: '31', text: '三年級 上學期' })
                result.push({ value: '32', text: '三年級 下學期' })
                result.push({ value: '41', text: '四年級 上學期' })
                result.push({ value: '42', text: '四年級 下學期' })
                break;
            case '51':
                result.push({ value: '11', text: '一年級 上學期' })
                result.push({ value: '12', text: '一年級 下學期' })
                result.push({ value: '21', text: '二年級 上學期' })
                result.push({ value: '22', text: '二年級 下學期' })
                result.push({ value: '31', text: '三年級 上學期' })
                result.push({ value: '32', text: '三年級 下學期' })
                result.push({ value: '41', text: '四年級 上學期' })
                result.push({ value: '42', text: '四年級 下學期' })
                result.push({ value: '51', text: '五年級 上學期' })
                break;
            case '52':
                result.push({ value: '11', text: '一年級 上學期' })
                result.push({ value: '12', text: '一年級 下學期' })
                result.push({ value: '21', text: '二年級 上學期' })
                result.push({ value: '22', text: '二年級 下學期' })
                result.push({ value: '31', text: '三年級 上學期' })
                result.push({ value: '32', text: '三年級 下學期' })
                result.push({ value: '41', text: '四年級 上學期' })
                result.push({ value: '42', text: '四年級 下學期' })
                result.push({ value: '51', text: '五年級 上學期' })
                result.push({ value: '52', text: '五年級 下學期' })
                break;
            case '61':
                result.push({ value: '11', text: '一年級 上學期' })
                result.push({ value: '12', text: '一年級 下學期' })
                result.push({ value: '21', text: '二年級 上學期' })
                result.push({ value: '22', text: '二年級 下學期' })
                result.push({ value: '31', text: '三年級 上學期' })
                result.push({ value: '32', text: '三年級 下學期' })
                result.push({ value: '41', text: '四年級 上學期' })
                result.push({ value: '42', text: '四年級 下學期' })
                result.push({ value: '51', text: '五年級 上學期' })
                result.push({ value: '52', text: '五年級 下學期' })
                result.push({ value: '61', text: '六年級 上學期' })
                break;
            case '62':
                result.push({ value: '11', text: '一年級 上學期' })
                result.push({ value: '12', text: '一年級 下學期' })
                result.push({ value: '21', text: '二年級 上學期' })
                result.push({ value: '22', text: '二年級 下學期' })
                result.push({ value: '31', text: '三年級 上學期' })
                result.push({ value: '32', text: '三年級 下學期' })
                result.push({ value: '41', text: '四年級 上學期' })
                result.push({ value: '42', text: '四年級 下學期' })
                result.push({ value: '51', text: '五年級 上學期' })
                result.push({ value: '52', text: '五年級 下學期' })
                result.push({ value: '61', text: '六年級 上學期' })
                result.push({ value: '62', text: '六年級 下學期' })
                break;
            case '71':
                result.push({ value: '11', text: '一年級 上學期' })
                result.push({ value: '12', text: '一年級 下學期' })
                result.push({ value: '21', text: '二年級 上學期' })
                result.push({ value: '22', text: '二年級 下學期' })
                result.push({ value: '31', text: '三年級 上學期' })
                result.push({ value: '32', text: '三年級 下學期' })
                result.push({ value: '41', text: '四年級 上學期' })
                result.push({ value: '42', text: '四年級 下學期' })
                result.push({ value: '51', text: '五年級 上學期' })
                result.push({ value: '52', text: '五年級 下學期' })
                result.push({ value: '61', text: '六年級 上學期' })
                result.push({ value: '62', text: '六年級 下學期' })
                result.push({ value: '71', text: '七年級 上學期' })
                break;
            case '72':
                result.push({ value: '11', text: '一年級 上學期' })
                result.push({ value: '12', text: '一年級 下學期' })
                result.push({ value: '21', text: '二年級 上學期' })
                result.push({ value: '22', text: '二年級 下學期' })
                result.push({ value: '31', text: '三年級 上學期' })
                result.push({ value: '32', text: '三年級 下學期' })
                result.push({ value: '41', text: '四年級 上學期' })
                result.push({ value: '42', text: '四年級 下學期' })
                result.push({ value: '51', text: '五年級 上學期' })
                result.push({ value: '52', text: '五年級 下學期' })
                result.push({ value: '61', text: '六年級 上學期' })
                result.push({ value: '62', text: '六年級 下學期' })
                result.push({ value: '71', text: '七年級 上學期' })
                result.push({ value: '72', text: '七年級 下學期' })
                break;
            default:
        }
        return result;
    }

    // 數據配置處理 //////////////////////////////////////////////

    radar_chart = (data) => {
        const { DataView } = DataSet
        const dv = new DataView().source(data)
        dv.transform({
            type: 'fold',
            fields: ['完成度', 'PR值'],
            key: 'key',    // key字段
            value: 'score', // value字段
        });

        return <Chart
            height={300}
            data={dv.rows}
            autoFit
            scale={{
                score: {
                    min: 0,
                    max: 100,
                }
            }}
            interactions={['legend-highlight']}
        >
            <Coordinate type="polar" radius={0.8} />
            <Tooltip shared />
            <Point
                position="item*score"
                color="key"
                shape="circle"
            />
            <Line
                position="item*score"
                color="key"
                size="2"
            />
            <Area
                position="item*score"
                color="key"
            />
            {

            }
            <Axis name="score" grid={{ line: { type: 'line' } }} />
            {

            }
            <Axis name="item" line={false} />
        </Chart>
    }

    // 介面互動處理 //////////////////////////////////////////////

    tab_change = async (key) => {
        const { talents, student, department, enrollmnetYear, showGradeSemester } = this.state
        const { token } = this.props.user
        const talent = talents.find(x => x.nidTalent === key)
        const tagret = {
            gidLearnMapMeta: talent.gidLearnMapMeta,
            nidLearnMapMeta: talent.nidLearnMapMeta,
            student: student,
            department: department,
            enrollmnetYear: enrollmnetYear,
            gidTalent: talent.gidTalent,
            nidTalent: talent.nidTalent,
            gradeSemester: showGradeSemester
        }
        //console.log('tagret', tagret)

        this.setState({ tableloading: true, items: [], nidTalent: key })
        const result = await req_single_cms_learnmap_completed_index(tagret, token)
        if (result) {
            if (result.total > 0) {
                const rows = result.data

                let pro_rows = []
                let pro_data = []
                let com_rows = []
                let com_data = []

                rows.forEach((row) => {
                    if (row.abilityCategoryCode === 'PROFESSION') {
                        const pro_chart = {
                            item: row.abilityAcronym,
                            完成度: parseFloat((Math.sqrt(row.abilityValueMe) * 10).toFixed(2)),
                            PR值: parseFloat((row.abilityPRValue).toFixed(2))
                        }
                        pro_data.push(pro_chart)
                        pro_rows.push(row)
                    } else {
                        const com_chart = {
                            item: row.abilityAcronym,
                            完成度: parseFloat((Math.sqrt(row.abilityValueMe) * 10).toFixed(2)),
                            PR值: parseFloat((row.abilityPRValue).toFixed(2))
                        }
                        com_data.push(com_chart)
                        com_rows.push(row)
                    }
                })
                let temp = com_rows.concat(pro_rows);
                const items = temp
                const prodata = pro_data
                const comdata = com_data
                this.setState({ items, prodata, comdata })
                //console.log('items', items)
                //console.log('com_data', com_data)
            }
        }
        this.setState({ tableloading: false, nidTalent: key })
    }

    grade_semeter_change = (key) => {
        const { nidTalent } = this.state
        this.setState({ showGradeSemester: key }, () => {
            this.tab_change(nidTalent)
        })
    }

    btn_grade_semeter = () => {
        const { gradeSemesters, showGradeSemester } = this.state
        //console.log(showGradeSemester)
        return gradeSemesters.length > 0 ? gradeSemesters.map((row, idx) => <button key={idx} className={"btn " + (row.value.toString() === showGradeSemester.toString() ? "btn-success" : "btn-default")} onClick={() => this.grade_semeter_change(row.value.toString())}>{row.text}</button>) : ''
    }

    course_suggest_btn = (item) => {
        this.setState({ item, isSuggestModal: true })
    }

    avility_chart_btn = (item) => {
        this.setState({ item, isChartModal: true })  
    }

    /////////////////////////////////////////////////////////////  


    render() {
        const { loading, tableloading, talents, defaultKey, items, prodata, comdata, item, isChartModal, isSuggestModal} = this.state
        const tabPanes = talents.length > 0 ? talents.map((row, idx) => <TabPane tab={row.talentTwName} key={row.nidTalent}></TabPane>) : ''
        const columns = [
            {
                title: '能力屬性',
                width: 30,
                responsive: ['md'],
                render: (item) => {
                    const { abilityCategoryCode } = item
                    return (
                        <div className='text-center'>
                            <Tag color={abilityCategoryCode === 'PROFESSION' ? '#f50' : '#87d068'}> <i className={abilityCategoryCode === 'PROFESSION' ? 'fa fa-podcast' : 'fas fa-street-view'}></i>  {abilityCategoryCode === 'PROFESSION' ? '核心能力' : '基本素養'} </Tag>
                        </div>
                    )
                }
            },
            {
                title: '指標簡稱',
                dataIndex: 'abilityAcronym',
                width: 30,
            },
            {
                title: '指標名稱',
                dataIndex: 'abilityTwName',
                width: 60,
                responsive: ['md'],
            },
            {
                title: '完成度',
                width: 30,
                responsive: ['md'],
                render: (item) => {
                    const { abilityValueMe } = item
                    return (
                        <>
                            {(Math.sqrt(abilityValueMe) * 10).toFixed(2)}%
                        </>
                    )
                }
            },
            {
                title: 'PR值',
                width: 30,
                responsive: ['md'],
                render: (item) => {
                    const { abilityPRValue } = item
                    return (
                        <>
                            {(abilityPRValue).toFixed(2)}%
                        </>
                    )
                }
            },
            {
                title: 'PR值排名',
                width: 30,
                responsive: ['md'],
                render: (item) => {
                    const { rankPRValue, studentTotal } = item
                    return (
                        <>
                            第{rankPRValue}名，共{studentTotal}人
                        </>
                    )
                },
            },
            {
                title: '成長圖',
                width: 30,
                responsive: ['md'],
                render: (item) => {
                    const { talents, department, student, enrollmnetYear, maxGrade } = this.state
                    const talent = talents.filter(function (e) {
                        return e.nidTalent.toString() === item.nidTalent.toString()
                    })
                    const obj = {
                        Student: student,
                        Department: department,
                        EnrollmnetYear: enrollmnetYear,
                        MaxGrade: maxGrade,
                        PlanYearGid: talent[0].gidLearnMapMeta,
                        PlanYearNid: talent[0].nidLearnMapMeta,
                        TalentGid: talent[0].gidTalent,
                        TalentNid: talent[0].nidTalent,
                        AbilityCategoryCode: item.abilityCategoryCode,
                        Ability: item.gidTalentAbility,
                        AbilityName: item.abilityAcronym,
                    }
                    //console.log(obj)
                    return (
                        <div className='text-center'>
                            <button type="button" className="btn btn-primary btn-sm" onClick={() => this.avility_chart_btn(obj)}><i className="fas fa-chart-line"></i> 查閱</button>
                        </div>
                    )
                },
            },
            {
                title: '選課導航',
                width: 30,
                render: (item) => {
                    const { talents } = this.state
                    const talent = talents.filter(function (e) {
                        return e.nidTalent.toString() === item.nidTalent.toString()
                    })
                    const obj = {
                        abilityName: item.abilityAcronym,
                        nidLearnMapMeta: talent[0].nidLearnMapMeta,
                        nidTalent: talent[0].nidTalent,
                        gidTalentAbility: item.gidTalentAbility,

                    }
                    return (
                        <div className='text-center'>
                            <button type="button" className="btn btn-primary btn-sm" onClick={() => this.course_suggest_btn(obj)}><i className="fa fa-indent"></i> 查閱</button>
                        </div>
                    )
                },
            },
        ]
        const htmlItems = talents.length > 0 ? (<>
            <Tabs defaultActiveKey={defaultKey} onChange={this.tab_change}>
                {tabPanes}
            </Tabs>
            <div style={{ marginBottom: '4px' }}>
                <span>可選年級學期：</span> {this.btn_grade_semeter()}
            </div>
            <Card>
                {tableloading ? (<div className='text-center'>
                    <p />
                    <button className="btn " type="button" disabled>
                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" style={{ marginRight: '4px' }}></span>
                        Loading...
                    </button>
                </div>) : (<><div className='row'>
                    <div className="col-xs col-md-6">
                        <Divider orientation="left" plain ><Tag color='#87d068'> <i className="fas fa-street-view"></i> 基本素養</Tag></Divider>
                        {this.radar_chart(comdata)}
                    </div>
                    <div className="col-xs col-md-6">
                        <Divider orientation="left" plain ><Tag color='#f50'> <i className="fa fa-podcast" aria-hidden="true"></i> 核心能力</Tag></Divider>
                        {this.radar_chart(prodata)}
                    </div>
                </div>
                </>)}
                <Table
                    bordered
                    style={{ width: '99%' }}
                    loading={tableloading}
                    scroll={{ y: 360 }}
                    rowKey='gidTalentAbility'
                    dataSource={items}
                    pagination={false}
                    columns={columns}
                />
            </Card>
        </>) : (<Alert
            message="無相關資訊(此功能僅適用日四技查詢)"
            type="warning"
            closable
        />)

        return (
            <>
                {loading ? (<div className='text-center'>
                    <p />
                    <button className="btn " type="button" disabled>
                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" style={{ marginRight: '4px' }}></span>
                        Loading...
                    </button>
                </div>) : (<>
                    {htmlItems}

                    <Modal
                        destroyOnClose={true}
                        visible={isChartModal}
                        width={600}
                        onOk={() => {
                            this.setState({ isChartModal: false })
                        }}
                        onCancel={() => {
                            this.setState({ isChartModal: false })
                        }}
                        cancelButtonProps={{ style: { display: 'none' } }}
                    >
                        <CoursemapStudentAbilityChartModal trend={item} />
                    </Modal>
                    <Modal
                        destroyOnClose={true}
                        visible={isSuggestModal}
                        width={800}
                        onOk={() => {
                            this.setState({ isSuggestModal: false })
                        }}
                        onCancel={() => {
                            this.setState({ isSuggestModal: false })
                        }}
                        cancelButtonProps={{ style: { display: 'none' } }}
                    >
                        <CoursemapStudentSuggestCourseModal course={item} />
                    </Modal>

                </>)}
            </>
        )
    }
}

export default connect(
    state => ({ user: state.user }),
    {}
)(CoursemapStudentCompletedIndex)